require('./details.scss');

const { SplitFeatureFlags } = require('bk-web-app/features');

const deps = [
  'bench.main-app',
  require('angular-ui-router'),
  require('./card').name,
  require('./overview').name,
  require('./assignments').name,
  require('./teamComments').name,
  require('./clientSummary').name,
  require('./companyDetails').name,
  require('ui/web/navbar').name,
  require('data/service/featureFlagService').name,
];

module.exports = angular
  .module('bench.app.mainapp.details', deps)

  .config(($stateProvider, $urlRouterProvider, MainAppConfig) => {
    const baseUrl = `/app/${MainAppConfig.clientId}`;
    const stateName = 'bench.details';
    const path = MainAppConfig.routes[stateName];

    $stateProvider.state(stateName, {
      abstract: true,
      url: path,
      template: require('./details.html'),
      controllerAs: 'vm',
      controller(User, featureFlagService) {
        this.clientId = User.getClientId();

        this.navStates = [
          {
            label: 'Client Details',
            state: 'bench.details.card',
          },
          {
            label: 'User Assignments',
            state: 'bench.details.assignments',
          },
          {
            label: 'Team Comments',
            state: 'bench.details.teamComments',
          },
        ];

        this.navStates.push({
          label: 'Client Summary',
          state: 'bench.details.clientSummary',
        });

        // Check feature flag for Company Profile tab (async)
        featureFlagService
          .isFeatureEnabledWithBookkeepers(SplitFeatureFlags.COMPANY_DETAILS_PAGE)
          .then(isEnabled => {
            if (isEnabled) {
              this.navStates.push({
                label: 'Company Profile',
                state: 'bench.details.companyDetails',
              });
            }
          });

        return this;
      },
    });

    // Register Client Summary state
    $stateProvider.state('bench.details.clientSummary', {
      url: '/client-summary',
      views: {
        '': {
          template: '<client-summary />',
        },
      },
    });

    // Register Company Details state
    $stateProvider.state('bench.details.companyDetails', {
      url: '/company-details',
      views: {
        '': {
          template: '<company-details />',
        },
      },
    });

    return $urlRouterProvider.when(`${baseUrl}${path}`, `${baseUrl}${path}/card`);
  });
